/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'pl',
  Pagination: {
    items_per_page: '/ stronę',
    jump_to: 'Idź do',
    jump_to_confirm: 'potwierdzać',
    page: '',
    prev_page: 'Poprzednia strona',
    next_page: 'Następna strona',
    prev_5: 'Poprzednie 5 stron',
    next_5: 'Następne 5 stron',
    prev_3: 'Poprzednie 3 strony',
    next_3: 'Następne 3 strony'
  },
  DatePicker: {
    lang: {
      placeholder: 'Wybierz datę',
      rangePlaceholder: ['Data początkowa', 'Data końcowa'],
      locale: 'pl_PL',
      today: 'Dzisiaj',
      now: 'Teraz',
      backToToday: 'Ustaw dzisiaj',
      ok: 'Ok',
      clear: 'Wyczyść',
      month: 'Miesiąc',
      year: 'Rok',
      timeSelect: 'Ustaw czas',
      dateSelect: 'Ustaw datę',
      monthSelect: 'Wybierz miesiąc',
      yearSelect: 'Wybierz rok',
      decadeSelect: 'Wybierz dekadę',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Poprzedni miesiąc (PageUp)',
      nextMonth: 'Następny miesiąc (PageDown)',
      previousYear: 'Ostatni rok (Ctrl + left)',
      nextYear: 'Następny rok (Ctrl + right)',
      previousDecade: 'Ostatnia dekada',
      nextDecade: 'Następna dekada',
      previousCentury: 'Ostatni wiek',
      nextCentury: 'Następny wiek'
    },
    timePickerLocale: {
      placeholder: 'Wybierz godzinę'
    }
  },
  TimePicker: {
    placeholder: 'Wybierz godzinę'
  },
  Calendar: {
    lang: {
      placeholder: 'Wybierz datę',
      rangePlaceholder: ['Data początkowa', 'Data końcowa'],
      locale: 'pl_PL',
      today: 'Dzisiaj',
      now: 'Teraz',
      backToToday: 'Ustaw dzisiaj',
      ok: 'Ok',
      clear: 'Wyczyść',
      month: 'Miesiąc',
      year: 'Rok',
      timeSelect: 'Ustaw czas',
      dateSelect: 'Ustaw datę',
      monthSelect: 'Wybierz miesiąc',
      yearSelect: 'Wybierz rok',
      decadeSelect: 'Wybierz dekadę',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Poprzedni miesiąc (PageUp)',
      nextMonth: 'Następny miesiąc (PageDown)',
      previousYear: 'Ostatni rok (Ctrl + left)',
      nextYear: 'Następny rok (Ctrl + right)',
      previousDecade: 'Ostatnia dekada',
      nextDecade: 'Następna dekada',
      previousCentury: 'Ostatni wiek',
      nextCentury: 'Następny wiek'
    },
    timePickerLocale: {
      placeholder: 'Wybierz godzinę'
    }
  },
  Table: {
    filterTitle: 'Menu filtra',
    filterConfirm: 'OK',
    filterReset: 'Wyczyść',
    selectAll: 'Zaznacz bieżącą stronę',
    selectInvert: 'Odwróć zaznaczenie'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Anuluj',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Anuluj'
  },
  Transfer: {
    searchPlaceholder: 'Szukaj',
    itemUnit: 'obiekt',
    itemsUnit: 'obiekty'
  },
  Upload: {
    uploading: 'Wysyłanie...',
    removeFile: 'Usuń plik',
    uploadError: 'Błąd wysyłania',
    previewFile: 'Podejrzyj plik',
    downloadFile: 'Pobieranie pliku'
  },
  Empty: {
    description: 'Brak danych'
  }
};
